import { useEffect } from 'react';

/**
 * Inject (and clean up) a JSON-LD <script> in <head>. Used to publish grounded
 * structured data for the splash. Static SPA caveat: this runs client-side, so
 * JS-executing crawlers see it; non-executing ones rely on the static
 * title/description in index.html.
 */
export function useJsonLd(data: Record<string, unknown>, id = 'ld-localbusiness') {
  useEffect(() => {
    let script = document.getElementById(id) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = id;
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(data);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, [data, id]);
}
